module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "SortContainer"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("sort.label")))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localValue),
      expression: "localValue"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.localValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t("sort.default")))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PRICE_ASC"
    }
  }, [_vm._v(_vm._s(_vm.$t("sort.price_asc")))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PRICE_DESC"
    }
  }, [_vm._v(_vm._s(_vm.$t("sort.price_desc")))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-712257ca!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/list/_partials/sort.vue
// module id = 265
// module chunks = 1